import moment from 'moment';
import { SpecialExitParkReasonMap, ReviewStatusMap } from '@/types/exception-management/dictionaries';

export default function() {
  return {
    adapterDataForViewModel: {
      releaseCausesHandler: {
        dataMap: SpecialExitParkReasonMap,
        model: [],
        onChange: (str: String) => {
          this.filterParam.releaseCauses = str;
        }
      },
      reviewStatushandler: {
        dataMap: ReviewStatusMap,
        model: [],
        onChange: (str: String) => {
          this.filterParam.reviewStatus = str;
        }
      },

      plateModel: false
    },
    parkIds: [], // 车场ID集合,多车场逗号分隔
    plateHead: '', // 车牌头
    plateTail: '',
    exitStartTime: moment(new Date()).format('YYYY-MM-DD 00:00:00'), // 开始时间
    exitEndTime: moment(new Date()).format('YYYY-MM-DD 23:59:59'), // 结束时间
    releaseCauses: '', //放行原因
    reviewStatus: '', //审核状态
    operater: '',
    source: [], //操作来源
    enterTimeOrderBy: '',
    exitTimeOrderBy: '',
    unpaidAmountOrderBy: '',
    cancelAmountOrderBy: '',
    totalAmountOrderBy: '',
    channelIds: [],
    cancelAmout: '', //减免金额 单位：元
    unpaidAmout: '' //应收未收金额 单位：元
  };
}
